function CategoryBg({ className, title, line }) {
  return (
    <div
      className={`${className} h-20 w-64 px-5 py-3 rounded-lg whitespace-nowrap cursor-pointer`}
    >
      {line && <div className=" w-10 h-1 bg-white" />}
      <h3 className="font-bold text-white text-lg">{title}</h3>
    </div>
  );
}

export default CategoryBg;
